import { render, staticRenderFns } from "./MortgageCompareWidget.vue?vue&type=template&id=745e142e&scoped=true"
import script from "./MortgageCompareWidget.vue?vue&type=script&lang=js"
export * from "./MortgageCompareWidget.vue?vue&type=script&lang=js"
import style0 from "./MortgageCompareWidget.vue?vue&type=style&index=0&id=745e142e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745e142e",
  null
  
)

export default component.exports